import { render, staticRenderFns } from "./VsTabs.vue?vue&type=template&id=5cd4b482&lang=pug&"
import script from "./VsTabs.vue?vue&type=script&lang=js&"
export * from "./VsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd4b482')) {
      api.createRecord('5cd4b482', component.options)
    } else {
      api.reload('5cd4b482', component.options)
    }
    module.hot.accept("./VsTabs.vue?vue&type=template&id=5cd4b482&lang=pug&", function () {
      api.rerender('5cd4b482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsTabs.vue"
export default component.exports